<template>
  <ymap-marker
    :coords="courierCoordinates"
    :marker-id="`courier-${courier.id}-${courierCoordinates[0]}-${courierCoordinates[1]}-${courier.courier_current_geo.time}`"
    :balloon-template="balloonTemplate"
    :hint-content="hintContent"
    :icon="markerIcon"
  />
</template>

<script>
  import { ymapMarker } from 'vue-yandex-maps'
  import { TRANSPARENT_PIXEL, avatarColorByName } from './marker-helpers'

  export default {
    name: 'CourierMarker',
    components: {
      ymapMarker,
    },
    props: {
      courier: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      courierInitials () {
        try {
          return (
            this.courier.last_name[0] + this.courier.first_name[0]
          ).toUpperCase()
        } catch {
          return 'К'
        }
      },
      courierFullName () {
        let name = ''
        try {
          name = `${this.courier.last_name} ${this.courier.first_name}`
        } catch {
          name = 'Курьер'
        }
        return name
      },
      courierCoordinates () {
        return [this.courier.courier_current_geo.lat, this.courier.courier_current_geo.let]
      },
      courierGeo () {
        return this.courier.courier_current_geo || {}
      },
      balloonTemplate () {
        let courierOrders = `<h3>${this.courierFullName}</h3>`
        courierOrders += `<p>(обновлено в ${this.courier.courier_current_geo.time})</p>`
        try {
          this.courier.orders_in_delivery.forEach(order => {
            courierOrders += (`#${order.code} - ${order.order_status_description}<br>`)
          })
        } catch {
          return 'Нет заказов'
        }
        return courierOrders
      },
      hintContent () {
        return `${this.courierFullName} (обновлено в ${this.courier.courier_current_geo.time})`
      },

      avatarUrl () {
        return this.courier.image_url || ''
      },
      avatarColor () {
        return avatarColorByName(this.courierFullName)
      },
      ordersCount () {
        return Array.isArray(this.courier.orders_in_delivery)
          ? this.courier.orders_in_delivery.length
          : 0
      },
      markerLayout () {
        const photo = this.avatarUrl
          ? `<img class="crm-courier-marker__photo" src="${this.avatarUrl}" onerror="this.style.display='none'"/>`
          : ''
        const badge = this.ordersCount
          ? `<span class="crm-courier-marker__badge">${this.ordersCount}</span>`
          : ''
        return `
          <div class="crm-courier-marker">
            <div class="crm-courier-marker__pin" style="background:${this.avatarColor}">
              <span class="crm-courier-marker__initials">${this.courierInitials}</span>
              ${photo}
            </div>
            ${badge}
          </div>`
      },
      markerIcon () {
        return {
          layout: 'default#imageWithContent',
          imageHref: TRANSPARENT_PIXEL,
          imageSize: [54, 54],
          imageOffset: [-27, -54],
          contentOffset: [0, 0],
          contentLayout: this.markerLayout,
        }
      },
    },
  }
</script>

<style lang="less">
.crm-courier-marker {
  position: relative;
  width: 54px;
  height: 54px;

  // капля в стиле метки филиала: повёрнутый квадрат со скруглением трёх углов,
  // острый угол смотрит точно вниз, на координату курьера
  &__pin {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 38px;
    height: 38px;
    border: 3px solid #fff;
    border-radius: 50% 50% 50% 0;
    transform: rotate(-45deg);
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 600;
    font-size: 13px;
    overflow: hidden;
  }

  &__initials {
    transform: rotate(45deg);
  }

  // счётчик заказов в доставке; скрыт, когда заказов нет
  &__badge {
    position: absolute;
    top: 2px;
    right: 0;
    z-index: 2;
    min-width: 22px;
    height: 22px;
    padding: 0 5px;
    border-radius: 11px;
    border: 2px solid #fff;
    box-sizing: border-box;
    background: #ff005f;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__photo {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    // фото - круг, вписанный в округлую часть капли: собственный радиус
    // обрезает снимок, остриё остаётся с заливкой аватарного цвета
    border-radius: 50%;
    // компенсируем поворот капли (круг при повороте остаётся кругом)
    transform: rotate(45deg);
  }
}
</style>
